import React from 'react';
import PropTypes from 'prop-types';

import style from './style.module.scss';

export function SetTemperature(props) {
  const updateTemperature = (event) => {
    let temperature =
      event.target.value === undefined ? props.temperature : event.target.value;
    props.setTemperature(temperature);
  };
  return (
    <>
      <input
        className={style.setTemparature}
        type='text'
        value={props.temperature}
        tabIndex='0'
        maxlength='3'
        onChange={updateTemperature}
      />
      <h3 className={style.setTemparature_degree}>°C</h3>
    </>
  );
}
SetTemperature.propTypes = {
  /**
   * State to store the setTemperature value
   */
  temperature: PropTypes.number,
  /**
   * Set temperature is a function to change the set Temperature
   */
  setTemperature: PropTypes.func,
};
